module.exports = __webpack_public_path__ + "static/media/pitstop_rig_constructing.a77989a2.mp4";